export default __webpack_public_path__ + "static/media/drag-handle-vertical.9f909f3d.svg";